export default __webpack_public_path__ + "locales/ru/DeleteThirdPartyDialog.json?hash=4a47bc53977f02f8d9c09e8ca99235da";